<template>
  <div class="shadow-none">
    <div :class="['be-loading', { 'be-loading-active': isBusy }]">
      <div
        class="flex flex-col md:flex-row md:justify-between md:items-center gap-[10px] md:gap-0 mb-2"
      >
        <div class="flex flex-col gap-[16px]">
          <button
            class="text-[14px] font-semibold leading-[20px] cursor-pointer focus:outline-none py-[5px] text-[#353535] max-w-max"
          >
            Returns
          </button>
        </div>
        <div class="flex gap-[10px] items-center">
          <button
            class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none"
          >
            <span class="">
              <img src="/assets/icon/sort.svg" alt="" />
            </span>
            Filters
          </button>
          <button
            class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none max-w-max w-full"
            @click="initializeCustomerReturns"
            v-if="hasPermission('Product_Category_Create')"
          >
            <i class="feather icon-plus"></i> &nbsp;New Returns
          </button>
        </div>
      </div>
      <div>
        <div class="table-responsive">
          <table class="table m-0 p-0 dataTable text-nowrap min-h-[150px]">
            <thead class="bg-white">
              <tr>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Return Id
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Customers Name
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Return Date
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Created by
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Entry Date
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr v-if="loading">
                <td colspan="12" class="text-center">
                  <div
                    class="text-center"
                    style="padding-top: 100px; padding-bottom: 50px"
                  >
                    <span
                      class="fa-solid fa-spinner fa-spin text-[#2463EB]"
                      style="font-size: 8rem"
                    ></span>
                    <h3
                      class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                      style="padding-bottom: 100px"
                    >
                      Please wait while we load the list
                    </h3>
                  </div>
                </td>
              </tr>
              <tr v-for="cr in customerReturnList" :key="cr.id" v-else>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ cr.returnId }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ cr.customer }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ formatDate(cr.returnDate) }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ cr.createdBy }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ formatDate(cr.entryDate) }}
                </td>
                <td>
                  <button
                    class="btn-no-border"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span
                      class="text-[#98a2b3] dropdown text-2xl cursor-pointer relative outline-none active:outline-none shadow-none"
                    >
                      ...
                    </span>
                  </button>
                  <ul
                    class="dropdown-menu shadow-none"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <li
                      class="text-[14px] font-normal leading-[14px] text-[#353535] cursor-pointer py-[10px] px-[16px]"
                      @click.prevent="viewDetails(cr.id, cr.returnId)"
                    >
                      View Details
                    </li>
                  </ul>
                </td>
              </tr>
              <tr v-if="customerReturnList.length == 0 && !loading">
                <td colspan="7">
                  <div class="text-center" style="padding-top: 50px">
                    <span
                      style="font-size: 4.615rem"
                      class="mdi mdi-tag-multiple"
                    ></span>
                  </div>
                  <h3 class="text-center" style="padding-bottom: 100px">
                    You don't have any customer returns.
                  </h3>
                </td>
              </tr>
            </tbody>
          </table>
          <Pagination
            :limit="pageSize"
            :count="pageCount"
            :page="page"
            :itemsCount="count"
            @changePage="gotoPage"
            @changeLimit="changeLimit"
          />
        </div>
      </div>
    </div>

    <!--1st add modals -->
    <div class="modal fade py-1" id="mod-add-customer-returns" role="dialog">
      <div class="modal-dialog mx-auto">
        <div class="modal-content p-[24px] bg-[#f8f8f8]">
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]"
            >
              Initiate Returns
            </h4>
            <button
              class="text-2xl text-[#353535]"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body m-0 p-0">
            <div class="mb-[16px]">
              <label
                class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
                >Select Customer</label
              >
              <div>
                <select2 placeholder="Select a customer" v-model="customerID">
                  <option selected disabled>Select a customer</option>
                  <option
                    v-for="customer in customersOptions"
                    :key="customer.key"
                    :value="customer.key"
                  >
                    {{ customer.value }}
                  </option>
                </select2>
                <ul
                  v-if="v1.seletedCustomer"
                  class="parsley-errors-list filled"
                >
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] mt-[16px]">
            <button
              class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              :disabled="isBusyModal"
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click.prevent="initializeCustomerReturnsSearch"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Done</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 2nd modal -->
    <div class="modal fade" id="mod-add-customer-returns-search" role="dialog">
      <div
        class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content modal-content rounded-none bg-[#f8f8f8] p-[20px] md:p-[40px] h-[100dvh]"
        >
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535]"
            >
              Initiate Returns
            </h4>
            <button
              class="text-2xl text-[#353535]"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body m-0 p-0">
            <div>
              <small>You can search by filling any of the fields</small>
            </div>
            <div class="my-[16px]">
              <label
                class="text-[#353535] font-bold-500 text-[14px] leading-[20px]"
                >Search Order number</label
              >
              <div>
                <input
                  class="bg-transparent border-[1.5px] border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Enter Order Number"
                  type="text"
                  v-model.number="orderNumber"
                />
              </div>
            </div>
            <div class="mb-[16px]">
              <label
                class="text-[#353535] font-bold-500 text-[14px] leading-[20px]"
                >Select Date</label
              >
              <div>
                <input
                  class="bg-transparent border-[1.5px] border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select Date"
                  type="date"
                  :max="maxDate"
                  v-model="date"
                />
              </div>
            </div>
            <div class="mb-[16px]">
              <label
                class="text-[#353535] font-bold-500 text-[14px] leading-[20px]"
                >Search Product Name</label
              >
              <div>
                <input
                  class="bg-transparent border-[1.5px] border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="text"
                  placeholder="Enter Product Name"
                  v-model.number="productName"
                />
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] w-full">
            <button
              class="bg-transparent border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              :disabled="isBusyModal"
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click.prevent="getMerchantFulfilledOrders"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Search</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 3rd modal -->

    <!-- popup modal -->
    <div
      class="modal fade py-1"
      id="mod-add-customer-returns-items"
      role="dialog"
    >
      <div class="modal-dialog max-w-[450px] mx-auto w-full relative">
        <div class="modal-content p-[10px] md:p-[20px] bg-[#f8f8f8]">
          <button
            class="absolute right-6 top-4 text-2xl outline-none focus:outline-none"
            type="button"
            data-dismiss="modal"
            aria-hidden="true"
          >
            <span class="mdi mdi-close"></span>
          </button>
          <div class="text-center">
            <div class="flex justify-center items-center my-[16px]">
              <img src="/assets/img/alarm.png" alt="" />
            </div>
            <p class="text-[14px] font-normal text-[#96a0b5] md:mx-2">
              Are you sure you want to return this stock?
            </p>
          </div>
          <div class="flex items-center justify-center gap-[8px] mt-[16px]">
            <button
              class="border border-solid border-[#96a0b5] rounded-[8px] text-[#96a0b5] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] py-[16px] w-full outline-none focus:outline-none"
              type="button"
              @click.prevent="dontAddReturnsTobucket"
            >
              No, I don't
            </button>
            <button
              :disabled="isBusyModal"
              class="border-[1px] bg-[#2463eb] rounded-[8px] text-white border-solid px-[16px] sm:px-[24px] text-[14px] md:text-[16px] py-[16px] w-full outline-none focus:outline-none"
              type="button"
              @click.prevent="addReturnsTobucket"
            >
              {{ isBusyModal ? "Loading..." : "Yes, I do" }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- confirm 1 -->
    <div
      class="modal fade colored-header colored-header-primary"
      id="mod-successfull-returns"
      role="dialog"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header modal-header-colored">
            <h4 class="modal-title p-1">
              <strong>Customer Returns</strong>
            </h4>
            <button
              class="close md-close"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
              @click="cancel"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <p class="text-center font-bold">
              Your have successfully completed <br />
              customer returns
            </p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" type="button">
              <span> Done </span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <viewCustomerReturns
      :returnItemDetails="lists"
      :returnListDetails="returnListDetails"
      :closeModal="closeModal"
      :isBusy="isBusy"
      :load="load"
      v-if="isModalVisible"
      :returnID="returnID"
      :completeReturns="completeReturns"
      :cancelCustomerReturns="cancelCustomerReturns"
      :returnDetailsiisActive="returnDetailsiisActive"
      :returnDetails="returnDetails"
      :actionsList="actionsList"
      :editReturnsData="editReturnsData"
      :deleteReturns="deleteReturns"
      :addProduct="addProduct"
      :ReverseModal="ReverseModal"
      :returnAnotherProductFromThisOrder="returnAnotherProductFromThisOrder"
    />

    <div class="modal fade z-[111111] py-1" id="mod-action-res" role="dialog">
      <div class="modal-dialog mx-auto">
        <div class="modal-content p-[24px] bg-[#f8f8f8]">
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]"
            >
              {{ action }} Action
            </h4>
            <button
              class="text-2xl text-[#353535]"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body m-0 p-0">
            <p class="text-[#353535] font-normal text-[14px] leading-[20px]">
              Are you sure you want to <strong>{{ action }}</strong> this
              transaction?
            </p>
            <div class="flex items-center gap-[8px] mt-[16px]">
              <button
                class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
                type="button"
                @click.prevent="closeDeleteReverseModal"
              >
                No, I don't
              </button>
              <button
                :disabled="isBusyModal"
                class="bg-[#DC2828] border-[#DC2828]  border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
                type="button"
                @click.prevent="reverse(itemID)"
              >
                <span v-if="isBusy">Busy...</span>
                <span v-else>Yes, I do</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade overflow-y-scroll z-[1111111111111] overflow-x-hidden"
      id="modi-add-customer-returns-items"
      role="dialog"
    >
      <div
        class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content modal-content rounded-none bg-[#f8f8f8] p-[20px] md:p-[40px]"
        >
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535]"
            >
              Initiate Returns
            </h4>

            <button
              @click="closeModalz"
              class="text-2xl text-[#353535]"
              type="button"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body m-0 p-0">
            <div class="py-[16px]">
              <label
                class="text-[#353535] font-bold-500 text-[14px] leading-[20px]"
                >Order List</label
              >
              <div>
                <select
                  class="bg-transparent border-[1.5px] border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  v-model="returns.orderListNumber"
                  @change="getProductList($event.target.value)"
                >
                  <option disabled selected value>Select Order</option>
                  <option
                    v-for="o in orderList"
                    :key="o.id"
                    :value="o.orderNumber"
                  >
                    {{ o.orderNumber }}
                  </option>
                </select>
                <ul
                  v-if="v1.orderListNumber"
                  class="parsley-errors-list filled"
                >
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="mb-[16px]">
              <label
                class="text-[#353535] font-bold-500 text-[14px] leading-[20px]"
                >Select Product</label
              >
              <div>
                <select
                  class="bg-transparent border-[1.5px] border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  :disabled="isBusy || bucketEdiitMode == true"
                  v-model="returns.product"
                  @change="getProductDetailsList($event.target.value)"
                >
                  <option disabled selected value>Select Product</option>
                  <option v-for="p in productDetails" :key="p.id" :value="p.id">
                    {{ p.description }}
                  </option>
                </select>
                <ul v-if="v1.product" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="mb-[16px]">
              <label
                class="text-[#353535] font-bold-500 text-[14px] leading-[20px]"
                >Product Quantity</label
              >
              <div>
                <input
                  class="bg-transparent border-[1.5px] border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="number"
                  disabled
                  placeholder="Enter Product Quantity"
                  v-model.number="returns.productQuantity"
                />
                <ul
                  v-if="v1.productQuantity"
                  class="parsley-errors-list filled"
                >
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="mb-[16px]">
              <label
                class="text-[#353535] font-bold-500 text-[14px] leading-[20px]"
                >Enter quantity you wish to return</label
              >
              <div>
                <input
                  class="bg-transparent border-[1.5px] border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="number"
                  placeholder="Enter Product desired Quantity"
                  v-model.number="returns.desiredQuantity"
                />
                <ul
                  v-if="v1.desiredQuantity"
                  class="parsley-errors-list filled"
                >
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="mb-[16px]">
              <label
                class="text-[#353535] font-bold-500 text-[14px] leading-[20px]"
                >Return Action</label
              >
              <div>
                <select
                  class="bg-transparent border-[1.5px] border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  v-model="returns.action"
                >
                  <option
                    v-for="acL in actionsList"
                    :key="acL.id"
                    :value="acL.id"
                  >
                    {{ acL.label }}
                  </option>
                </select>
                <ul v-if="v1.action" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="mb-[16px]">
              <label
                class="text-[#353535] font-bold-500 text-[14px] leading-[20px]"
                >Warehouse</label
              >
              <div>
                <select
                  class="bg-transparent border-[1.5px] border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  v-model="returns.locationId"
                  @input="getSubLocationsById($event)"
                >
                  <option
                    v-for="loc in Locations"
                    :key="loc.id"
                    :value="loc.id"
                  >
                    {{ loc.name }}
                  </option>
                </select>
                <ul v-if="v1.locationId" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="mb-[16px]">
              <label
                class="text-[#353535] font-bold-500 text-[14px] leading-[20px]"
                >Storage Area</label
              >
              <div>
                <select
                  class="bg-transparent border-[1.5px] border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  v-model="returns.subLocationId"
                >
                  <option
                    v-for="loc in SubLocations"
                    :key="loc.id"
                    :value="loc.id"
                  >
                    {{ loc.name }}
                  </option>
                </select>
                <ul v-if="v1.subLocationId" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="mb-[16px]">
              <label
                class="text-[#353535] font-bold-500 text-[14px] leading-[20px]"
                >Reasons</label
              >
              <div>
                <v-select
                  v-model="returns.reasons"
                  id="roleSelector"
                  class="style-chooser"
                  multiple
                  :options="reasonList"
                  :reduce="(value) => value.id"
                  @input="isSelectReasons($event)"
                />
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] w-full">
            <button
              class="bg-transparent border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button"
              data-dismiss="modal"
              @click="clearInput"
            >
              Cancel
            </button>
            <button
              :disabled="isBusyModal"
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click="updateAddTobucket"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>{{
                bucketEdiitMode ? "Update Returns" : "Add"
              }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import Select2 from "@/components/Select2";
import { helper } from "@/helper";
import SystemPermissions from "@/permissions";
import moment from "moment";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import GeneralDeleteCaution from "../components/GeneralDeleteCaution.vue";
import GeneralDeleteMessage from "../components/GeneralDeleteMessage.vue";
import Pagination from "../components/Pagination.vue";
import viewCustomerReturns from "../components/Inventory/viewCustomerReturns.vue";

export default {
  mixins: [SystemPermissions.Mixin],
  name: "ProductsBundle",
  components: {
    Select2,
    GeneralDeleteCaution,
    GeneralDeleteMessage,
    Pagination,
    vSelect,
    viewCustomerReturns,
  },

  data() {
    return {
      testList: [],
      isModalVisible: false,
      isBusy: false,
      isBusyModal: false,
      load: false,
      loading: false,
      returnCount: 0,
      action: "",
      itemID: "",
      count: 0,
      page: 1,
      pageNumber: 0,
      pageSize: 10,
      pageCount: 0,
      hasNext: false,
      hasPrev: false,
      isGlobal: false,
      endDate: "",
      startDate: "",
      returnDetailsiisActive: false,
      customerReturnList: [],
      MerchantFulfilledOrdersList: [],
      returnBucket: {
        customerId: "",
        returned: "",
        details: [],
      },
      customers: null,
      customersOptions: [],
      orderList: [],
      ProductList: null,
      productDetails: [],
      productDetailsItems: {},
      Locations: [],
      SubLocations: [],
      SubLocationsForUpdate: [],
      orderListNumber: "",
      returns: {
        orderListNumber: "",
        product: "",
        productQuantity: "",
        desiredQuantity: "",
        action: 0,
        locationId: "",
        subLocationId: "",
        reasons: [],
        count: 0,
        page: 0,
        pageNumber: 0,
        pageSize: 10,
        pageCount: 0,
        hasNext: false,
        hasPrev: false,
        isGlobal: false,
      },
      editReturns: {
        orderListNumber: null,
        product: null,
        productQuantity: null,
        desiredQuantity: null,
        action: null,
        locationId: null,
        subLocationId: null,
        reasons: null,
      },
      reasonList: [
        {
          label: "Damaged",
          id: "Damaged",
        },
        {
          label: "Wrong Product",
          id: "Wrong Product",
        },
        {
          label: "Expired",
          id: "Expired",
        },
        {
          label: "Wrong Quantity",
          id: "Wrong Quantity",
        },
        {
          label: "Others",
          id: "Others",
        },
      ],
      actionsList: [
        {
          label: "Disposed",
          id: 0,
        },
        {
          label: "Received",
          id: 1,
        },
      ],
      order: "",
      orderID: "",
      product: "",
      productQuantity: "",
      customerID: "",
      orderNumber: "",
      date: "",
      productName: "",
      seletedCustomer: "",
      maxDate: "",
      v1: {
        seletedCustomer: false,
      },
      filter: {
        status: "0",
        customerType: "0",
        qry: "",
        sortColumn: "name",
        sortDirection: "asc",
        showForMe: false,
      },

      v1: {
        orderListNumber: false,
        product: false,
        desiredQuantity: false,
        action: false,
        locationId: false,
        subLocationId: false,
      },

      bucketEdiitMode: false,
      bucketEditDataID: "",
      completeReturnsMessage: "",
      returnDetails: false,
      returnListDetails: [],
      returnItemDetails: [],
      returnID: null,
      returnDetailsID: null,
    };
  },

  created() {
    this.getCustomers();
    this.getCustomerReturns();
    this.getLocations();
    this.getSubLocations();
  },

  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
    allproducts() {
      return this.productDetails.filter(
        (product) =>
          !this.returnItemDetails.some((item) => item.product === product.id)
      );
    },
    lists() {
      return this.returnItemDetails;
    },
  },
  mounted() {
    this.maxDate = helper.preventFutureDateSelection();
  },

  methods: {
    closeModalz() {
      this.bucketEdiitMode = false;
      $("#modi-add-customer-returns-items").modal("hide");
      this.returns = {
        orderListNumber: null,
        product: null,
        productQuantity: null,
        desiredQuantity: null,
        action: null,
        locationId: null,
        subLocationId: null,
        reasons: null,
      };
    },
    addProduct() {
      this.bucketEdiitMode = false;
      $("#modi-add-customer-returns-items").modal("show");
      this.returns = { reasons: [] };
      this.reasonList = [
        {
          label: "Damaged",
          id: "Damaged",
        },
        {
          label: "Wrong Product",
          id: "Wrong Product",
        },
        {
          label: "Expired",
          id: "Expired",
        },
        {
          label: "Wrong Quantity",
          id: "Wrong Quantity",
        },
        {
          label: "Others",
          id: "Others",
        },
      ];
    },
    async viewDetails(id, returnID) {
      this.returnDetailsID = id;
      this.isBusy = true;
      await this.$http
        .get(`/OrderReturn/${id}/Details`)
        .then(function(res) {
          this.isModalVisible = true;
          this.returnListDetails = res.body.map((x) => x);
          this.returnID = returnID;
          this.returnDetails = true;
          this.returnDetails = true;
          this.returnDetailsiisActive = false;
          this.isBusy = false;
        })
        .catch(function() {
          this.isBusy = false;
        });

      $("#mod-filter").modal("hide");
      this.isBusy = false;
    },
    closeModal() {
      this.isModalVisible = false;
      this.returnDetails = false;
      this.returnDetailsiisActive = false;
      document.body.style.overflow = "auto";
      this.getCustomerReturns();
    },
    cancel() {
      $("#mod-edit").modal("hide");
    },
    initializeCustomerReturns() {
      $("#mod-add-customer-returns").modal("show");
    },
    isSelectReasons(e) {
      this.returns.reasons = e;
      // this.reasonList = this.reasonList.filter((reason) => !e.includes(reason.id));
    },
    closeDeleteReverseModal() {
      $("#mod-action-res").modal("hide");
      this.itemID = "";
      this.action = "";
    },
    back() {
      (this.returnDetails = false), (this.returnListDetails = []);
    },
    ReverseModal(id, action) {
      this.action = action;
      $("#mod-action-res").modal("show");
      this.itemID = id;
    },

    closeReverseModal() {
      $("#mod-action-res").modal("hide");
      this.itemID = "";
      this.action = "";
    },

    async reverse(detailID) {
      this.isBusy = true;
      await this.$http
        .put(`/OrderReturn/${this.returnDetailsID}/Reverse/${detailID}`)
        .then(function(res) {
          if (res.ok) {
            this.viewDetails(this.returnDetailsID, this.returnID);
            this.closeReverseModal();
            return;
          }
          this.isBusy = false;
        })
        .catch(function() {
          this.isBusy = false;
          this.closeReverseModal();
        });

      $("#mod-filter").modal("hide");
      this.isBusy = false;
    },

    getSubLocationsById(e) {
      this.returns.locationId = e.target.value;
      const res = this.SubLocationsForUpdate.filter(
        (el) =>
          el.location.id === e.target.value && el.id !== this.subLocationId
      );
      this.SubLocations = res;
    },

    async getCustomerReturns() {
      this.isBusy = true;
      this.loading = true;
      await this.$http
        .get(
          `/OrderReturn?pageNumber= ${this.pageNumber}&startDate=${
            this.startDate
          }&endDate=${this.endDate}&pageSize=${this.pageSize}&isGlobal=${!this
            .isGlobal}`
        )

        .then(function(res) {
          this.customerReturnList = res.body.data;
          this.page = res.body.pageNumber;
          this.pageSize = res.body.pageSize;
          this.count = res.body.count;
          this.pageCount = Math.ceil(res.body.count / res.body.pageSize);
          this.hasPrev = res.body.hasPrev;
          this.hasNext = res.body.hasNext;
          this.isBusy = false;
          this.loading = false;
        })
        .catch(function() {
          this.loading = false;
        });

      $("#mod-filter").modal("hide");
      this.isBusy = false;
    },

    updateAddTobucket() {
      if (this.bucketEdiitMode) {
        this.updateReturnsbucketData();
        this.isModalVisible = true;
        this.bucketEdiitMode = false;
        this.returnDetails = false;
        this.returnDetailsiisActive = true;
        this.returns = {
          orderListNumber: null,
          product: null,
          productQuantity: null,
          desiredQuantity: null,
          action: null,
          locationId: null,
          subLocationId: null,
          reasons: [],
        };
        return;
      } else {
        this.updateReturnsbucket();
      }
    },

    updateReturnsbucket() {
      let returnTableList;
      if (this.validateInput()) {
        let data = {
          orderDetailId: this.orderID,
          quantity: this.returns.desiredQuantity,
          action: parseInt(this.returns.action),
          reason: this.returns.reasons.toString(),
          subLocationId: this.returns.subLocationId,
        };
        this.returnBucket.details.push(data);
        this.returnBucket.customerId = this.customerID;
        this.returnBucket.returned = new Date().toISOString();

        let UnitPrice = this.productDetails
          .filter((x) => x.id == this.orderID)
          .map((x) => x.unitPrice)[0];
        let QuantityReturned = this.returns.desiredQuantity;

        returnTableList = {
          productName: this.productDetails
            .filter((x) => x.id == this.orderID)
            .map((x) => x.description)[0],
          productCode: this.productDetails
            .filter((x) => x.id == this.orderID)
            .map((x) => x.code)[0],
          productUnitPrice: this.productDetails
            .filter((x) => x.id == this.orderID)
            .map((x) => x.unitPrice)[0],
          productQuantityReturned: this.returns.desiredQuantity,
          productQuantity: this.returns.productQuantity,
          productAmount: UnitPrice * QuantityReturned,
          productDiscount: this.productDetails
            .filter((x) => x.id == this.orderID)
            .map((x) => x.discount)[0],
          productOrderNumber: this.returns.orderListNumber,
          productAction: this.actionsList
            .filter((x) => x.id == this.returns.action)
            .map((x) => x.label)[0],
          productLocation: this.SubLocations.filter(
            (x) => x.id == this.returns.subLocationId
          ).map((x) => x.name)[0],
          productwarehouseLocation: this.Locations.filter(
            (x) => x.id == this.returns.locationId
          ).map((x) => x.name)[0],
        };
        this.returnItemDetails.push({
          ...returnTableList,
          ...data,
          reasons: this.returns.reasons,
          locationId: this.returns.locationId,
          product: this.returns.product,
        });
        this.returnItemDetails.forEach((o, i) => (o.id = i + 1));
        $("#modi-add-customer-returns-items").modal("hide");
        $("#mod-add-customer-returns-items").modal("show");
        this.returns = { reasons: [] };
        // this.addReturnsTobucket();
      }
    },

    addReturnsTobucket() {
      $("#mod-add-customer-returns-items").modal("hide");
      this.isModalVisible = true;
      this.returnDetailsiisActive = true;
    },
    dontAddReturnsTobucket() {
      $("#mod-add-customer-returns-items").modal("hide");
      this.cancelCustomerReturns();
    },

    updateReturnsbucketData() {
      if (!this.bucketEditDataID) return;
      const itemDetailIndex = this.returnItemDetails.findIndex(
        (x) => x.orderDetailId === this.bucketEditDataID
      );
      const itemBucketIndex = this.returnBucket.details.findIndex(
        (x) => x.orderDetailId === this.bucketEditDataID
      );
      if (itemDetailIndex === -1 || itemBucketIndex === -1) {
        return;
      }

      // Extract required data
      const orderID = this.returns.product;
      const productDetail = this.productDetails.find(
        (x) => x.id === this.returns.product
      );
      const actionLabel =
        this.actionsList.find((x) => x.id === this.returns.action).label || "";
      const subLocationName =
        this.SubLocations.find((x) => x.id === this.returns.subLocationId)
          .name || "";
      const warehouseLocationName =
        this.Locations.find((x) => x.id === this.returns.locationId).name || "";

      // Update the bucket details
      let dataz = {
        orderDetailId: this.returns.product,
        quantity: this.returns.desiredQuantity,
        action: this.returns.action,
        reason: this.returns.reasons.toString(),
        subLocationId: this.returns.subLocationId,
      };
      // this.returnBucket.details[itemBucketIndex] = dataz;
      // Prepare return table data
      const returnTableList = {
        productName: productDetail.description || "",
        productCode: productDetail.code || "",
        productUnitPrice: productDetail.unitPrice || 0,
        productQuantityReturned: this.returns.desiredQuantity,
        productQuantity: this.returns.productQuantity,
        productAmount:
          (productDetail.unitPrice || 0) * this.returns.desiredQuantity,
        productDiscount: productDetail.discount || 0,
        productOrderNumber: this.returns.orderListNumber,
        productAction: actionLabel,
        productLocation: subLocationName,
        productwarehouseLocation: warehouseLocationName,
      };

      let updated = {
        ...this.returnItemDetails[itemDetailIndex],
        ...returnTableList,
        orderDetailId: this.returns.product,
        quantity: this.returns.desiredQuantity,
        action: this.returns.action,
        reason: this.returns.reasons.toString(),
        subLocationId: this.returns.subLocationId,
        reasons: this.returns.reasons,
        product: this.returns.product,
      };
      this.returnItemDetails[itemDetailIndex].orderDetailId =
        updated.orderDetailId;
      this.returnItemDetails[itemDetailIndex].quantity = updated.quantity;
      this.returnItemDetails[itemDetailIndex].action = updated.action;
      this.returnItemDetails[itemDetailIndex].reason = updated.reason;
      this.returnItemDetails[itemDetailIndex].product = updated.product;
      this.returnItemDetails[itemDetailIndex].productName = updated.productName;
      this.returnItemDetails[itemDetailIndex].productQuantityReturned =
        updated.productQuantityReturned;
      this.returnItemDetails[itemDetailIndex].subLocationId =
        updated.subLocationId;

      this.returnItemDetails[itemDetailIndex].productName =
        returnTableList.productName;
      this.returnItemDetails[itemDetailIndex].productCode =
        returnTableList.productCode;
      this.returnItemDetails[itemDetailIndex].productUnitPrice =
        returnTableList.productUnitPrice;
      this.returnItemDetails[itemDetailIndex].productQuantityReturned =
        returnTableList.productQuantityReturned;
      this.returnItemDetails[itemDetailIndex].productQuantity =
        returnTableList.productQuantity;
      this.returnItemDetails[itemDetailIndex].productAmount =
        returnTableList.productAmount;
      this.returnItemDetails[itemDetailIndex].productDiscount =
        returnTableList.productDiscount;
      this.returnItemDetails[itemDetailIndex].productOrderNumber =
        returnTableList.productOrderNumber;
      this.returnItemDetails[itemDetailIndex].productAction =
        returnTableList.productAction;
      this.returnItemDetails[itemDetailIndex].productLocation =
        returnTableList.productLocation;
      this.returnItemDetails[itemDetailIndex].productwarehouseLocation =
        returnTableList.productwarehouseLocation;

      this.returnBucket.details[itemBucketIndex] = dataz;
      this.$set(this.returnItemDetails, this.returnBucket, itemDetailIndex);
      // Reset returns data and close modal
      this.returns = { reasons: [] };
      $("#modi-add-customer-returns-items").modal("hide");
    },

    editReturnsData(ord) {
      this.bucketEdiitMode = true;
      this.viewRecord(ord);
    },
    deleteReturns(id) {
      let objIndex = this.returnItemDetails.findIndex((x) => x.id == id);
      this.returnItemDetails.splice(objIndex, 1);
      let objIndex2 = this.returnBucket.details.findIndex((x) => x.id == id);
      this.returnBucket.details.splice(objIndex2, 1);
    },

    returnAnotherProductFromThisOrder(x) {
      this.returns.orderListNumber = x;
      this.returns.product = null;
      this.returns.productQuantity = null;
      this.returns.desiredQuantity = null;
      this.returns.action = "";
      this.returns.locationId = null;
      this.returns.subLocationId = null;
      this.returns.reasons = null;
      this.isModalVisible = false;
      $("#modi-add-customer-returns-items").modal("show");
    },

    async completeReturns() {
      this.load = true;
      this.isBusy = true;
      try {
        let body = this.returnBucket;
        const res = await this.$http.post("/OrderReturn", body);
        const data = await res.json;
        this.closeModal();
        this.$toast.success(res.body, {
          icon: false,
          rtl: false,
        });
        this.isBusy = false;
        this.returnDetailsiisActive = false;
        $("#mod-add-customer-returns-items").modal("hide");
        this.cancelCustomerReturns();
        $("#mod-filter").modal("hide");
        this.load = false;
        this.isBusy = false;
      } catch (err) {
        this.load = false;
        this.isBusy = false;
        console.log(err);
        $("#mod-add-customer-returns-items").modal("hide");
      }
    },
    cancelCustomerReturns() {
      this.isModalVisible = false;
      this.returnItemDetails = [];
      this.customerID = "";
      this.returnBucket.customerId = "";
      this.returnBucket.returned = "";
      this.returnBucket.details = [];
      this.returnDetailsiisActive = false;
      this.returns = {
        orderListNumber: "",
        product: "",
        desiredQuantity: "",
        action: "",
        locationId: "",
        subLocationId: "",
        reasons: [],
      };
      this.orderID = "";
      this.closeModal();
      this.getCustomers();
      this.getCustomerReturns();
    },

    viewRecord(val) {
      this.bucketEditDataID = val.orderDetailId;
      let product = this.productDetails
        .filter((x) => x.description == val.productName)
        .map((x) => x.id)[0];
      this.returns = {
        orderListNumber: val.productOrderNumber,
        product: product,
        productQuantity: val.productQuantity,
        desiredQuantity: val.quantity,
        action: val.action,
        locationId: val.locationId,
        subLocationId: val.subLocationId,
        reasons: val.reasons,
      };
      this.returns.orderListNumber = val.productOrderNumber;
      $("#modi-add-customer-returns-items").modal("show");
    },

    clearInput() {
      this.returns = {
        orderListNumber: "",
        product: "",
        desiredQuantity: "",
        action: "",
        locationId: "",
        subLocationId: "",
        reasons: [],
      };
      this.orderID = "";
      this.cancelCustomerReturns();
      $("#modi-add-customer-returns-items").modal("show");
    },

    async getMerchantFulfilledOrders() {
      this.isBusy = true;
      await this.$http
        .get(
          `/Orders/getMerchantFulfilledOrders/${this.customerID}?OrderNumber=${this.orderNumber}&Query=${this.productName}&Created=${this.date}`
        )
        .then(function(res) {
          this.orderList = res.body;
          $("#mod-add-customer-returns-search").modal("hide");
          $("#modi-add-customer-returns-items").modal("show");
          this.isBusy = false;
        })
        .catch(function(err) {
          console.log(err);
        });
    },

    validateInput() {
      this.v1 = {
        orderListNumber: false,
        product: false,
        desiredQuantity: false,
        action: false,
        locationId: false,
        subLocationId: false,
      };
      var isValid = true;

      if (!this.returns.orderListNumber) {
        this.v1.orderListNumber = true;
        isValid = false;
      }

      if (!this.returns.product) {
        this.v1.product = true;
        isValid = false;
      }
      if (!this.returns.desiredQuantity) {
        this.v1.desiredQuantity = true;
        isValid = false;
      }
      if (!this.returns.locationId) {
        this.v1.locationId = true;
        isValid = false;
      }
      if (!this.returns.subLocationId) {
        this.v1.subLocationId = true;
        isValid = false;
      }

      return isValid;
    },

    getProductList(val) {
      this.productList = this.orderList.filter(
        (order) => order.orderNumber == val
      );
      this.productDetails = this.productList[0].details;
    },
    getProductDetailsList(value) {
      this.orderID = value;
      this.productDetailsItems = this.productDetails.filter(
        (product) => product.id == value
      );
      this.returns.productQuantity = this.productDetailsItems[0].quantity;
    },
    initializeCustomerReturnsSearch() {
      $("#mod-add-customer-returns").modal("hide");
      $("#mod-add-customer-returns-search").modal("show");
    },
    getLocations() {
      var t = "Location";
      var a = true;

      this.$http
        .get(
          "/Locations/getListNoPaging?active=" +
            a +
            "&parentId=" +
            this.user.parentId
        )
        .then(function(res) {
          this.Locations = res.body;
        })
        .catch(function() {});
    },
    getSubLocations() {
      var t = "Location";
      var a = true;

      this.$http
        .get(
          "/SubLocations/getListNoPaging?active=" +
            a +
            "&parentId=" +
            this.user.parentId +
            "&locationId="
        )
        .then(function(res) {
          this.SubLocations = res.body;
          this.SubLocationsForUpdate = res.body;
        })
        .catch(function() {});
    },
    initializeCustomerReturnsItems() {
      $("#mod-add-customer-returns-items").modal("show");
    },
    CustomerReturnssuccess() {
      $("#mod-successfull-returns").modal("show");
    },
    async getCustomers() {
      this.isBusy = true;
      await this.$http
        .get(`/Users/getItemListOfCustomers/${this.user.parentId}`)
        .then(function(res) {
          this.customersOptions = res.body.map((customer) => ({
            key: customer.id,
            value: customer.text,
          }));
          this.isBusy = false;
        })
        .catch(function() {
          this.isBusy = false;
        });

      $("#mod-filter").modal("hide");
      this.isBusy = false;
    },

    gotoPage(page) {
      this.page = page;
      this.getCustomerReturns();
    },
    changeLimit(limit) {
      this.pageSize = limit;
      this.getCustomerReturns();
    },
    prev() {
      this.page -= 1;
      this.getCustomerReturns();
    },
    next() {
      this.page += 1;
      this.getCustomerReturns();
    },
    formatDate(date) {
      return moment(date).format("ll");
    },
    formatMoney(val) {
      return helper.formatMoney(val);
    },
    formatNumber(val) {
      return helper.formatNumber(val);
    },
  },
};
</script>
